import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'Is this a physical product?',
  answer: 'No. It is a 100% digital product delivered instantly after purchase.'
}, {
  question: 'Is this suitable for complete beginners?',
  answer: 'Yes. The system starts from the fundamentals and gradually progresses to professional installations.'
}, {
  question: 'Will I learn Home Assistant?',
  answer: 'Yes. The course includes complete installation, configuration, integrations, automation, security, and system management.'
}, {
  question: 'Can I start offering Smart Home services after completing the system?',
  answer: 'Yes. The program teaches both the technical installation process and the business fundamentals required to begin offering Smart Home installation services.'
}, {
  question: 'How will I receive access?',
  answer: "Immediately after payment. You'll receive everything by email within minutes."
}, {
  question: 'Do I need an electrical license or previous technical experience?',
  answer: 'No previous experience is required to start learning. The system explains wiring fundamentals, safety, and installation planning from zero. For paid work you should always follow the local electrical regulations and licensing requirements that apply in your area.'
}, {
  question: 'Do I have to buy expensive equipment to follow the training?',
  answer: 'No. You can complete the entire system without buying anything. When you are ready to practice, the modules explain exactly which affordable devices to start with and how to build a starter kit step by step.'
}, {
  question: 'Does it cover Matter, Zigbee, Thread, Wi-Fi and ESPHome devices?',
  answer: 'Yes. You will learn how each communication protocol works, which devices are compatible with each ecosystem, and how to choose the right technology for every residential project.'
}, {
  question: 'Are the templates and checklists editable for my own business?',
  answer: 'Yes. Quotations, pricing worksheets, client questionnaires, installation reports, and handover forms are professional templates you can customize with your own brand, prices, and workflow.'
}, {
  question: 'Is this a one-time payment, and how does the refund work?',
  answer: 'It is a single payment for immediate lifetime access to the complete 6-in-1 system and all 5 premium bonuses. If it is not right for you, contact us within the first 7 days and we will refund 100% of your purchase.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white px-4 py-5" data-id="element-34" data-mp="2yn1q4vxjfb3n">
      <div className="mx-auto max-w-3xl" data-id="element-35" data-mp="2ylqn4ybx27dl">
        <h2 className="mb-3 text-center font-display text-xl font-extrabold uppercase sm:text-3xl" data-id="element-36" data-mp="2ulq8bckwnu60">
          Frequently Asked Questions
        </h2>
        <div className="space-y-2" data-id="element-37" data-mp="1n8xwxryrxqzn">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <article key={faq.question} className="overflow-hidden rounded-xl border border-brand-line bg-brand-light" data-id="element-38" data-mp="3uupoetsprsh5" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} className="flex w-full items-center justify-between gap-3 px-3 py-2.5 text-left transition-colors hover:bg-white sm:px-4" aria-expanded={isOpen} aria-controls={panelId} data-id="element-39" data-mp="2qx81z5cwu9g">
                  <span className="font-display text-[13px] font-semibold leading-snug text-brand-ink sm:text-base" data-id="element-40" data-mp="hfa2usspk72d">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-orange transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-41" data-mp="mfxvtk0hyxz8" />
                </button>
                {isOpen && <div id={panelId} className="px-3 pb-3 text-sm font-normal leading-snug text-brand-muted sm:px-4" data-id="element-42" data-mp="vcoywgdgvd3b">
                    {faq.answer}
                  </div>}
              </article>;
        })}
        </div>
      </div>
    </section>;
}